import { PlatformApiEnhancerFunction } from '../../../types/platformApi';

export function isBuilderComponentModelSupported(): boolean {
  return Boolean(
    (window as any).editorModel?.siteHeader?.builderComponentModel,
  );
}

export const builderComponentModelEnhancer: PlatformApiEnhancerFunction =
  () => {
    return {
      editor: {
        info: {
          isBuilderComponentModelSupported,
        },
      },
    };
  };
